// import stylesheets
import "../stylesheets/app.less";
import AVAILABLE_PAGES from "./pages";

class App {
  static init() {
    const html = document.querySelector("html");
    let page = "default";

    const prefix = "page-";
    for (const className of html.classList.values()) {
      if (className.startsWith(prefix)) {
        page = className.slice(prefix.length);
        break;
      }
    }

    if (AVAILABLE_PAGES[page]) {
      AVAILABLE_PAGES[page].init();
    }
  }

  onLoad() {}
}

App.init();
